(() => {
  const keys = {
    left: 'ArrowLeft',
    right: 'ArrowRight',
  };

  const tabItems = {};
  const tabSections = {};
  const tabBlockClassName = 'js-tabs-block';
  const tabItemClassName = 'js-tabs-item';
  const tabSectionClassName = 'js-tabs-section';
  const classNameForFadeIn = 'is-fadein';
  const tabBlocks = [...document.getElementsByClassName(tabBlockClassName)];

  if (tabBlocks.length === 0) {
    return;
  }

  const deactivateTabs = (tabBlockId) => {
    for (let i = 0; i < tabItems[tabBlockId].length; i += 1) {
      tabItems[tabBlockId][i].setAttribute('tabindex', '-1');
      tabItems[tabBlockId][i].setAttribute('aria-selected', 'false');
    }
    for (let i = 0; i < tabSections[tabBlockId].length; i += 1) {
      tabSections[tabBlockId][i].setAttribute('aria-hidden', 'true');
      tabSections[tabBlockId][i].classList.remove(classNameForFadeIn);
    }
  };

  const activateTab = (tab) => {
    tab.removeAttribute('tabindex');
    tab.setAttribute('aria-selected', 'true');
    tab.focus();

    const targetSectionId = tab.getAttribute('aria-controls');
    if (!targetSectionId) {
      throw new Error('controlled section is missing');
    }

    const targetSection = document.getElementById(targetSectionId);
    if (!targetSection) {
      throw new Error('controlled section is missing');
    }

    targetSection.removeAttribute('aria-hidden');
    targetSection.classList.add('is-fadein');
  };

  const changeTabByKeyup = (event, tabBlockId) => {
    const direction = {
      'ArrowLeft': -1,
      'ArrowRight': 1,
    };

    const key = event.code;
    if (key !== keys.left && key !== keys.right) {
      return;
    }

    const target = event.target;
    if (!target || target.index === undefined || tabBlockId === undefined) {
      return;
    }

    if (tabItems[tabBlockId][target.index + direction[key]]) {
      deactivateTabs(tabBlockId);
      activateTab(tabItems[tabBlockId][target.index + direction[key]]);
      return;
    }
    if (key === keys.left) {
      deactivateTabs(tabBlockId);
      activateTab(tabItems[tabBlockId][tabItems[tabBlockId].length - 1]);
      return;
    }
    if (key === keys.right) {
      deactivateTabs(tabBlockId);
      activateTab(tabItems[tabBlockId][0]);
    }
  };

  const clickEventListener = (event, tabBlockId) => {
    const tab = event.target;
    if (tabBlockId !== undefined) {
      deactivateTabs(tabBlockId);
      activateTab(tab);
    }
  };

  const keyupEventListener = (event, tabBlockId) => {
    if (!(event instanceof KeyboardEvent)) {
      return;
    }
    const key = event.code;
    if (key === keys.left || key === keys.right) {
      changeTabByKeyup(event, tabBlockId);
    }
  };

  const addEventListeners = (index, tabBlockId) => {
    tabItems[tabBlockId][index].addEventListener('click', (event) => clickEventListener(event, tabBlockId));
    tabItems[tabBlockId][index].addEventListener('keyup', (event) => keyupEventListener(event, tabBlockId));
    tabItems[tabBlockId][index].index = index;
  };

  const init = () => {
    for (const tabBlock of tabBlocks) {
      const tabBlockId = Number(tabBlock.id);
      tabItems[tabBlockId] = tabBlock.getElementsByClassName(tabItemClassName);
      tabSections[tabBlockId] = tabBlock.getElementsByClassName(tabSectionClassName);
      for (let i = 0; i < tabItems[tabBlockId].length; i += 1) {
        addEventListeners(i, tabBlockId);
      }
    }
  };

  window.addEventListener('DOMContentLoaded', init);
})();
